interface UserAgentData {
  platform?: string;
}

interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: UserAgentData;
}

export interface EventContext {
  page: {
    path: string;
    referrer: string;
    search: string;
    title: string;
    url: string;
  };
  userAgent: string;
  userAgentData: {
    platform: string;
  };
  locale: string;
  timezone: string;
}

export const getEventContext = (): EventContext => {
  const nav = navigator as NavigatorWithUserAgentData;
  return {
    page: {
      path: window.location.pathname,
      referrer: document.referrer,
      search: window.location.search,
      title: document.title,
      url: window.location.href,
    },
    userAgent: nav.userAgent,
    userAgentData: {
      platform: nav.userAgentData?.platform ?? "",
    },
    locale: nav.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};
